
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"9.886","height":"16.678"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 7272","d":"M.046 8.216l-.05.121.052.126 8.162 8.162.128.053.13-.054 1.359-1.359.053-.127-.054-.13-6.659-6.664 6.664-6.667.053-.127-.054-.13L8.493.082 8.475.064 8.347.011l-.131.054L.062 8.218z","fill":"#fff"}})])
          )
        }
      }
    